import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { HeaderStyle } from "../Common/styles/header";
// import GenerateSlotsModal from "./GenerateSlotsModal";
import {
  a11yProps,
  CustomTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import AppointmentsTab from "./AppointmentsTab";
// import { toastMessage } from "../../utils/toast";
import StudyAppointmentsDashboard from "./StudyAppointmentsDashboard";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const StudyAppointments = () => {
  const [selectedTab, setSelectedTab] = useState(
    sessionStorage.getItem("study_appt_tab") || "dashboard"
  );

  const [toggleSlots, setToggleSlots] = useState(false);

  // const [showGenerateModal, setShowGenerateModal] = useState(false);
  // const [showBookModal, setShowBookModal] = useState(false);

  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const open = Boolean(anchorEl);

  const handleToggleSlots = () => {
    setToggleSlots((prev) => !prev);
  };

  // const handleActionClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleActionClose = () => {
  //   setAnchorEl(null);
  // };

  const handleTabsChange = (_: any, newValue: string) => {
    sessionStorage.setItem("study_appt_tab", newValue);
    setSelectedTab(newValue);
  };

  // const openGenerateModal = () => {
  //   if (!sessionStorage.getItem("study_appt_room")) {
  //     toastMessage("warning", "Please select a room first");
  //     return;
  //   }
  //   handleActionClose();
  //   setShowGenerateModal(true);
  // };

  // const handleManualAppointment = () => {
  //   if (!sessionStorage.getItem("study_appt_room")) {
  //     toastMessage("warning", "Please select a room first");
  //     return;
  //   }
  //   handleActionClose();
  //   setShowBookModal(true);
  // };

  // const closeGenerateModal = () => {
  //   setShowGenerateModal(false);
  // };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h2" color="text.primary">
            Appointments
          </Typography>
        </Box>
        {/* <Box sx={{ ml: "auto" }}>
          {selectedTab === "calendar" && (
            <>
              <Button
                variant="contained"
                onClick={handleActionClick}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Actions
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleActionClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={openGenerateModal}>Generate Slots</MenuItem>
                <MenuItem onClick={handleManualAppointment}>
                  Manual Appointment
                </MenuItem>
              </Menu>
            </>
          )}
        </Box> */}
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={selectedTab} onChange={handleTabsChange}>
          <StyledTab label="Dashboard" value="dashboard" {...a11yProps(0)} />
          <StyledTab label="Calendar" value="calendar" {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <Box sx={{ p: 2.5, height: "calc(100% - 122px)", overflow: "auto" }}>
        <CustomTabPanel value={selectedTab} index={"dashboard"}>
          <StudyAppointmentsDashboard />
        </CustomTabPanel>
        <CustomTabPanel value={selectedTab} index={"calendar"}>
          <AppointmentsTab
            toggle={toggleSlots}
            refresh={handleToggleSlots}
            // showManualBooking={showBookModal}
            // setShowManualBooking={setShowBookModal}
          />
        </CustomTabPanel>
      </Box>

      {/* {showGenerateModal && (
        <GenerateSlotsModal
          open={showGenerateModal}
          onClose={closeGenerateModal}
          refresh={handleToggleSlots}
        />
      )} */}
    </>
  );
};

export default StudyAppointments;
